import { RouteConfig } from 'vue-router';

import store from '@/store';
import { partnerFilters } from '@/utils/partner';

export const partnersRoute: RouteConfig = {
  path: '/',
  component: () => import(/* webpackChunkName: "Partners" */ '@/views/main/partner/List.vue'),
  name: 'partners',
  beforeEnter(to, _from, next) {
    store.dispatch('partner/list', partnerFilters(to)).then(() => next());
  }
};
